import styled from "styled-components";

export const AnswerWrapper = styled.div`
  display: grid;
  grid-template-columns: ${({ other }) => (other ? "1fr 1fr 7fr" : "1fr 8fr")};
  justify-items: stretch;
  align-content: center;
  align-items: center;

  input[type="radio"] {
    justify-self: left;
    width: 55%;
    height: 2em;
    outline: 0;
  }
  input[type="checkbox"] {
    justify-self: center;
    width: 55%;
    height: 2em;
    outline: 0;
  }

  input[type="text"] {
    padding: 0.3em;
    width: 100%;
    border: none;
    outline: 0;
    box-sizing: border-box;
  }
`;
